package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.adults_international_txt
import com.eladfinish.bible.contest.adults_national_txt
import com.eladfinish.bible.contest.data.common.AssetReader
import com.eladfinish.bible.contest.introduction_adults_txt
import com.eladfinish.bible.contest.introduction_youth_txt
import com.eladfinish.bible.contest.screens.mikud.model.MikudLevelInfo
import com.eladfinish.bible.contest.screens.mikud.model.MikudType
import com.eladfinish.bible.contest.youth_religious_txt
import com.eladfinish.bible.contest.youth_state_txt
import dev.icerock.moko.resources.AssetResource

class GetMikudLevelInfoUseCase(
    private val assetReader: AssetReader,
) {

    operator fun invoke(
        mikudType: MikudType,
    ): MikudLevelInfo {

        fun read(assetResource: AssetResource, withSpacing: Boolean = false): String =
            assetReader.readFile(assetResource).trim().let {
                if (withSpacing) "$it\n\n" else it
            }

        return when (mikudType) {
            MikudType.YOUTH -> MikudLevelInfo(
                intro = read(SharedRes.assets.mikudLevels.youth.introduction_youth_txt, withSpacing = true),
                part1 = read(SharedRes.assets.mikudLevels.youth.youth_state_txt, withSpacing = true),
                part2 = read(SharedRes.assets.mikudLevels.youth.youth_religious_txt),
            )

            MikudType.ADULTS -> MikudLevelInfo(
                intro = read(SharedRes.assets.mikudLevels.adults.introduction_adults_txt, withSpacing = true),
                part1 = read(SharedRes.assets.mikudLevels.adults.adults_national_txt, withSpacing = true),
                part2 = read(SharedRes.assets.mikudLevels.adults.adults_international_txt),
            )

            else -> throw IllegalArgumentException(
                "Unsupported mikudType: $mikudType (expected YOUTH or ADULTS)"
            )
        }
    }

}
